export const localeClassNameLabel = {
  'en-US': 'en',
  'zh-CN': 'zh',
};
